<template>
  <v-dialog v-model="modal" max-width="1000" persistent>
    <v-card>
      <v-form ref="form">
        <v-card-title>
          <v-tabs color="secondary" v-model="indexTab">
            <span
              class="am-t2 bold"
              style="
                align-self: center;
                display: inline-block;
                color: rgba(0, 0, 0, 0.87) !important;
              "
            >
              <template v-if="comite"> Membre de la direction </template>
              <template v-else> Liquidateur </template>
            </span>
            <v-tab :disabled="tabDisabled && indexTab !== 0"> Personne physique </v-tab>
            <v-tab :disabled="tabDisabled && indexTab !== 1"> Personne morale </v-tab>
          </v-tabs>
        </v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="12" v-if="comite">
              <a-fonction-combobox
                dense
                filled
                label="Fonction"
                v-model.trim="fonction"
                :rules="[requiredRule(), serverRule(`${prefix}.fonction`)]"
                @input="clear(`${prefix}.fonction`)"
                data-testid="fonction"
              />
            </v-col>

            <v-col cols="12">
              <v-row dense v-if="indexTab === 0" key="phy">
                <v-col cols="12" md="2">
                  <a-civilite-select
                    dense
                    filled
                    label="Civilité"
                    v-model="civilite"
                    :rules="[requiredRule(), serverRule(`${prefix}.civilite`)]"
                    @input="clear(`${prefix}.civilite`)"
                    data-testid="civilite"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    dense
                    filled
                    label="Nom"
                    v-model.trim="nom"
                    :rules="[requiredRule(), serverRule(`${prefix}.nom`)]"
                    @input="clear(`${prefix}.nom`)"
                    data-testid="nom"
                  />
                </v-col>
                <v-col cols="12" :md="comite ? 4 : 6">
                  <v-text-field
                    dense
                    filled
                    label="Prénom"
                    v-model.trim="prenom"
                    :rules="[requiredRule(), serverRule(`${prefix}.prenom`)]"
                    @input="clear(`${prefix}.prenom`)"
                    data-testid="prenom"
                  />
                </v-col>
                <v-col cols="12" md="2" v-if="comite">
                  <a-nationalite-autocomplete
                    dense
                    filled
                    label="Nationalité"
                    v-model.trim="nationalite"
                    :rules="[requiredRule(), serverRule(`${prefix}.nationalite`)]"
                    @input="clear(`${prefix}.nationalite`)"
                    data-testid="nationalite"
                  />
                </v-col>
              </v-row>
              <v-row dense v-if="indexTab === 1" key="mor">
                <v-col cols="2">
                  <a-civilite-select
                    dense
                    filled
                    label="Civilité du représentant"
                    v-model="civilite"
                    :rules="[requiredRule(), serverRule(`${prefix}.civilite`)]"
                    @input="clear(`${prefix}.civilite`)"
                    data-testid="civilite-representant"
                  />
                </v-col>
                <v-col cols="5">
                  <v-text-field
                    dense
                    filled
                    label="Nom du représentant"
                    v-model.trim="nomRepresentant"
                    :rules="[requiredRule(), serverRule(`${prefix}.nomRepresentant`)]"
                    @input="clear(`${prefix}.nomRepresentant`)"
                    data-testid="nom-representant"
                  />
                </v-col>
                <v-col cols="5">
                  <v-text-field
                    dense
                    filled
                    label="Prénom du représentant"
                    v-model.trim="prenomRepresentant"
                    :rules="[requiredRule(), serverRule(`${prefix}.prenomRepresentant`)]"
                    @input="clear(`${prefix}.prenomRepresentant`)"
                    data-testid="prenom-representant"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <a-forme-juridique-combobox
                    dense
                    filled
                    label="Forme juridique"
                    v-model.trim="formeJuridique"
                    :rules="[requiredRule(), serverRule(`${prefix}.formeJuridique`)]"
                    @input="clear(`${prefix}.formeJuridique`)"
                    data-testid="forme-juridique"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    dense
                    filled
                    label="Dénomination"
                    v-model.trim="denomination"
                    :rules="[requiredRule(), serverRule(`${prefix}.denomination`)]"
                    @input="clear(`${prefix}.denomination`)"
                    data-testid="denomination"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    dense
                    filled
                    label="N° Inscription"
                    v-model.trim="numeroInscription"
                    :rules="[serverRule(`${prefix}.numeroInscription`)]"
                    @input="clear(`${prefix}.numeroInscription`)"
                    data-testid="numero-inscription"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-text-field
                dense
                filled
                label="Adresse"
                v-model.trim="adresse.adresse"
                :rules="[requiredRule(), serverRule(`${prefix}.adresse.adresse`)]"
                @input="clear(`${prefix}.adresse.adresse`)"
                data-testid="adresse"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                dense
                filled
                label="Complément adresse"
                v-model.trim="adresse.complementAdresse"
                :rules="[serverRule(`${prefix}.adresse.complementAdresse`)]"
                @input="clear(`${prefix}.adresse.complementAdresse`)"
                data-testid="complement-adresse"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                dense
                filled
                label="Code postal"
                v-model.trim="adresse.codePostal"
                :rules="[requiredRule(), serverRule(`${prefix}.adresse.codePostal`)]"
                @input="clear(`${prefix}.adresse.codePostal`)"
                data-testid="code-postal"
              />
            </v-col>
            <v-col cols="12" md="6">
              <a-commune-combobox
                dense
                filled
                label="Commune"
                v-model.trim="adresse.commune"
                :codePostal="adresse.codePostal"
                :rules="[requiredRule(), serverRule(`${prefix}.adresse.commune`)]"
                @codePostal="codePostalChange"
                @input="clear(`${prefix}.adresse.commune`)"
                data-testid="commune"
              />
            </v-col>
            <v-col cols="12" md="4">
              <a-pays-autocomplete
                dense
                filled
                label="Pays"
                v-model.trim="adresse.pays"
                :rules="[serverRule(`${prefix}.adresse.pays`)]"
                @input="clear(`${prefix}.adresse.pays`)"
                data-testid="pays"
              />
            </v-col>

            <template v-if="comite">
              <v-col cols="12" md="6">
                <v-text-field
                  dense
                  filled
                  label="Téléphone"
                  v-model.trim="telephone"
                  :rules="[serverRule(`${prefix}.telephone`)]"
                  @input="clear(`${prefix}.telephone`)"
                  data-testid="telephone"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  dense
                  filled
                  label="Adresse courriel"
                  v-model.trim="email"
                  :rules="[serverRule(`${prefix}.email`)]"
                  @input="clear(`${prefix}.email`)"
                  data-testid="email"
                />
              </v-col>
            </template>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn data-testid="valider-edition-personne" @click="valide" color="primary">Sauvegarder</v-btn>
          <v-btn data-testid="annuler-edition-personne" ref="non" @click="ferme">Annuler</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import makeMembreDialog from "./makeMembreDialog";

function mapCommun(src, dest) {
  src = src || {};
  dest.action = src.action;
  dest.uuid = src.uuid;
  dest.localUuid = src.localUuid;
  dest.fonction = src.fonction;
  dest.civilite = src.civilite;
  dest.email = src.email;
  dest.telephone = src.telephone;
  dest.numeroInscription = src.numeroInscription;
  dest.estFondateur = src.estFondateur != null ? src.estFondateur : true;
  const adresse = src.adresse || {};
  dest.adresse = {
    adresse: adresse.adresse,
    complementAdresse: adresse.complementAdresse,
    codePostal: adresse.codePostal,
    commune: adresse.commune,
    pays: adresse.pays,
  };
}

export function mapPhysique(src, dest) {
  dest.nom = src.nom;
  dest.prenom = src.prenom;
  dest.nationalite = src.nationalite;
  mapCommun(src, dest);
}

export function mapMorale(src, dest) {
  dest.formeJuridique = src.formeJuridique;
  dest.denomination = src.denomination;
  dest.nomRepresentant = src.nomRepresentant;
  dest.prenomRepresentant = src.prenomRepresentant;
  mapCommun(src, dest);
}

export default {
  mixins: [makeMembreDialog(mapPhysique, mapMorale)],
  props: {
    mode: {
      type: String,
      required: false,
    },
  },
  computed: {
    liquidation() {
      return "liquidateur" === this.mode;
    },
    comite() {
      return !this.liquidation;
    },
  },
  methods: {
    codePostalChange(codePostaux) {
      const code = this.adresse?.codePostal || "";
      if (codePostaux?.length) {
        const match = codePostaux.find(cp => cp.startsWith(code));
        if (match) {
          this.adresse.codePostal = match;
        }
      }
    },
  },
};
</script>
